
// export const url_server = "http://localhost/moodle/";
// export const url_webservice = "http://localhost/moodle/webservice/rest/server.php"; 
// export const url_server_moodle = "http://localhost:3003/api/v1/"; 

export const url_server = "https://moodle-98665-0.cloudclusters.net/";
export const url_webservice = "https://moodle-98665-0.cloudclusters.net/webservice/rest/server.php"; 
export const url_server_moodle = "https://nodejsclusters-98667-0.cloudclusters.net/api/v1/"; 
